import { http } from '../../utils';
const controller = 'psm/shareds';
export const uploadFile = async (formData) => {
    return await http.post(`${controller}/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
export const getFile = async (filePath) => {
    return await http.get(`${controller}/get-file`, {
        params: {
            fileUrl: filePath
        },
        responseType: 'blob'
    });
};
export const deleteFile = async (filePath) => {
    return await http.delete(`${controller}/delete-file`, {
        params: {
            fileUrl: filePath
        }
    });
};
export const downloadZipFile = async (fileName, fileUrls) => {
    if (!fileUrls.length) {
        throw new Error('Danh sách file rỗng!');
    }
    const response = await http.post(`${controller}/download-zip`, fileUrls, {
        params: { fileName },
        responseType: 'blob'
    });
    // Tạo link tải về
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
};
